import {BroadcastChannel} from 'broadcast-channel';

const USER_ACTIVE_SESSION_CHANNEL = 'user-active-session-channel';
const USER_ACTIVE_SESSION_MSG = 'user-active-session-msg';

const channel = new BroadcastChannel<string>(USER_ACTIVE_SESSION_CHANNEL);

export const onBroadcastChannelPostMessage = () => {
    void channel.postMessage(USER_ACTIVE_SESSION_MSG);
};

export const onBroadcastChannelMessage = (callback: () => void) => {
    channel.onmessage = (event: string) => {
        if (event === USER_ACTIVE_SESSION_MSG) {
            callback();
        }
    };
};
